import { NgModule } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { TableModule } from '@openng/optimus-ui/table';
import { GeneSummaryRoutingModule } from './gene-summary-routing.module';
import { GeneSummaryComponent } from './gene-summary.component';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '@shared';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  imports: [
    BaseChartDirective,
    FontAwesomeModule,
    CommonModule,
    GeneSummaryRoutingModule,
    TableModule,
    BrowserModule,
    SharedModule,
    BsDropdownModule,
  ],
  declarations: [GeneSummaryComponent],
})
export class GeneSummaryModule {}
